export const PROCESS_INSTANCE_QUERY = 'p';
export const PRODUCT_INSTANCE_QUERY = 'pr';
